document.addEventListener('DOMContentLoaded', function () {

  // ─── Utilities ───────────────────────────────────────────────────────────────

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // ─── 1. Image Gallery Swap ───────────────────────────────────────────────────

  var mainImage = qs('#pe-main-image');
  var counterCurrent = qs('#pe-counter-current');
  var counterTotal = qs('#pe-counter-total');
  var thumbs = qsa('.pe-hero__thumb');

  if (mainImage && thumbs.length) {
    var totalCount = thumbs.length + 1;
    counterTotal.textContent = pad(totalCount);

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.imgSrc;
        var alt = thumb.dataset.imgAlt;

        mainImage.src = src;
        mainImage.alt = alt;

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        counterCurrent.textContent = pad(idx + 2);
      });
    });
  }

  // Hero thumbnail strip: subtle parallax on inner image (pointer only; no change to click / swap).
  if (
    thumbs.length &&
    window.matchMedia &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    var peThumbParaStrength = 6;
    var peThumbParaScale = 1.08;
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      if (!img) return;
      thumb.addEventListener('mousemove', function (e) {
        img.style.transition = 'none';
        var r = thumb.getBoundingClientRect();
        var nx = (e.clientX - r.left - r.width * 0.5) / (r.width * 0.5);
        var ny = (e.clientY - r.top - r.height * 0.5) / (r.height * 0.5);
        if (nx < -1) nx = -1;
        if (nx > 1) nx = 1;
        if (ny < -1) ny = -1;
        if (ny > 1) ny = 1;
        img.style.transform =
          'translate3d(' +
          (nx * peThumbParaStrength).toFixed(2) +
          'px,' +
          (ny * peThumbParaStrength).toFixed(2) +
          'px,0) scale(' +
          peThumbParaScale +
          ')';
      });
      thumb.addEventListener('mouseleave', function () {
        img.style.transition = '';
        img.style.transform = 'translate3d(0,0,0) scale(1)';
      });
    });
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Strip query string and any _NNNx size suffix so URLs from different
  // size variants of the same Shopify CDN image compare as equal.
  function getBaseImageUrl(url) {
    if (!url) return '';
    return url.split('?')[0].replace(/_\d+x(\.[^.]+)$/, '$1');
  }

  // Show src in the main image slot. If it matches a thumb, reuse that
  // thumb's click handler (updates counter + active state automatically).
  // Otherwise update the main image element directly and reset the counter.
  function swapMainImage(src, alt) {
    if (!mainImage) return;
    var base = getBaseImageUrl(src);
    var matched = thumbs.find(function (t) {
      return t.dataset.imgSrc && getBaseImageUrl(t.dataset.imgSrc) === base;
    });
    if (matched) {
      matched.click();
    } else {
      mainImage.src = src;
      if (alt != null) mainImage.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (counterCurrent) counterCurrent.textContent = '01';
    }
  }

  // ─── 2. Lightbox ─────────────────────────────────────────────────────────────

  var lightbox = qs('#pe-lightbox');
  var lightboxImg = qs('#pe-lightbox-img');
  var lightboxCounter = qs('#pe-lightbox-counter');
  var lightboxClose = qs('#pe-lightbox-close');
  var lightboxPrev = qs('#pe-lightbox-prev');
  var lightboxNext = qs('#pe-lightbox-next');
  var lightboxOverlay = qs('#pe-lightbox-overlay');
  var galleryItems = qsa('.pe-media__item--image');
  var lightboxImages = galleryItems.map(function (item) {
    var img = qs('img', item);
    return img ? (img.dataset.fullSrc || img.src) : '';
  }).filter(Boolean);
  var lightboxAlts = galleryItems.map(function (item) {
    var img = qs('img', item);
    return img ? img.alt : '';
  });
  var currentLightboxIndex = 0;

  function openLightbox(index) {
    if (!lightbox || !lightboxImages.length) return;
    currentLightboxIndex = index;
    updateLightbox();
    lightbox.removeAttribute('hidden');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('hidden', '');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateLightbox() {
    lightboxImg.src = lightboxImages[currentLightboxIndex];
    lightboxImg.alt = lightboxAlts[currentLightboxIndex] || '';
    lightboxCounter.textContent = (currentLightboxIndex + 1) + ' / ' + lightboxImages.length;
  }

  function lightboxStep(dir) {
    currentLightboxIndex = (currentLightboxIndex + dir + lightboxImages.length) % lightboxImages.length;
    updateLightbox();
  }

  galleryItems.forEach(function (item, idx) {
    item.addEventListener('click', function () { openLightbox(idx); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(idx); }
    });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxOverlay) lightboxOverlay.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function () { lightboxStep(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function () { lightboxStep(1); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox || lightbox.hasAttribute('hidden')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lightboxStep(-1);
    if (e.key === 'ArrowRight') lightboxStep(1);
  });

  // ─── 3. Variant Selection ────────────────────────────────────────────────────

  var productData = window.__peProductData || {};
  var variants = productData.variants || [];
  var variantIdInput = qs('#pe-variant-id');
  var priceDisplay = qs('#pe-current-price');
  var comparePriceDisplay = qs('.pe-price__compare');
  var atcBtn = qs('#pe-atc-btn');
  var stickyAtcBtn = qs('#pe-sticky-atc');
  var stickyPrice = qs('#pe-sticky-price');
  var sizeBtns = qsa('.pe-size-btn');
  var swatchBtns = qsa('.pe-swatch');

  var selectedOptions = {};

  if (variants.length) {
    var firstVariant = variants.find(function (v) { return v.id === productData.currentVariantId; }) || variants[0];
    if (firstVariant) {
      firstVariant.options.forEach(function (val, idx) {
        selectedOptions[idx] = val;
      });
    }
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (opt, idx) {
        return selectedOptions[idx] === undefined || selectedOptions[idx] === opt;
      });
    });
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    var price = formatMoney(variant.price);
    if (priceDisplay) priceDisplay.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;

    if (comparePriceDisplay) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceDisplay.textContent = formatMoney(variant.compare_at_price);
        comparePriceDisplay.style.display = '';
      } else {
        comparePriceDisplay.style.display = 'none';
      }
    }

    var available = variant.available;
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      atcBtn.classList.toggle('pe-atc-btn--soldout', !available);
    }
    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = !available;
      stickyAtcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    // Swap main image to the variant's assigned photo
    if (variant.featured_image && variant.featured_image.src) {
      var vSrc = variant.featured_image.src
        .replace(/_\d+x(\.[^.?]+)/, '$1')        // strip any existing size suffix
        .replace(/(\.[^.?]+)(\?|$)/, '_1200x$1$2'); // add 1200w for display quality
      swapMainImage(vSrc, variant.featured_image.alt || '');
    }
  }

  function formatMoney(cents) {
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sizeIndex = parseInt(btn.dataset.sizeIndex, 10);
      var sizeVal = btn.dataset.size;

      selectedOptions[sizeIndex] = sizeVal;

      sizeBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      var matched = findVariant();
      if (matched) updateVariantUI(matched);
    });
  });

  swatchBtns.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var colorIndex = parseInt(swatch.dataset.colorIndex, 10);
      var colorVal = swatch.dataset.color;

      selectedOptions[colorIndex] = colorVal;

      swatchBtns.forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');

      filterSizesByColor(colorVal, colorIndex);

      var matched = findVariant();
      if (matched) updateVariantUI(matched);
    });
  });

  qsa('.pe-option-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optIdx = parseInt(btn.dataset.optionIndex, 10);
      var optVal = btn.dataset.optionValue;

      selectedOptions[optIdx] = optVal;

      qsa('.pe-option-btn[data-option-index="' + optIdx + '"]').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      var matched = findVariant();
      if (matched) updateVariantUI(matched);
    });
  });

  // ─── 7. Color Swatch Sync (filter sizes by active color) ────────────────────

  function filterSizesByColor(colorVal, colorIndex) {
    var availableSizes = variants
      .filter(function (v) { return v.options[colorIndex] === colorVal; })
      .map(function (v) {
        var sizeIndex = (colorIndex === 0) ? 1 : 0;
        return { size: v.options[sizeIndex], available: v.available, id: v.id };
      });

    sizeBtns.forEach(function (btn) {
      var sizeVal = btn.dataset.size;
      var match = availableSizes.find(function (s) { return s.size === sizeVal; });
      if (match) {
        btn.style.display = '';
        btn.classList.toggle('is-soldout', !match.available);
        btn.dataset.variantId = match.id;
        btn.dataset.available = match.available;
      } else {
        btn.style.display = 'none';
      }
    });
  }

  // ─── 4. Quantity Stepper ────────────────────────────────────────────────────

  var qtyInput = qs('#pe-qty-input');
  var qtyMinus = qs('#pe-qty-minus');
  var qtyPlus = qs('#pe-qty-plus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      if (!isNaN(val) && val >= 1) qtyInput.value = val + 1;
    });
  }

  // ─── 5. Sticky Bar + IntersectionObserver ────────────────────────────────────

  var stickyBar = qs('#pe-sticky-bar');
  var heroAtcBtn = qs('#pe-atc-btn');

  if (stickyBar && heroAtcBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      });
    }, { threshold: 0.1 });

    observer.observe(heroAtcBtn);
  }

  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      var form = qs('#pe-product-form');
      if (form) form.submit();
    });
  }

  // ─── 6. Story Video Autoplay ─────────────────────────────────────────────────
  // On mobile portrait the story section is below the fold at page load.
  // Calling play() immediately puts the video in a pending-play state
  // (paused===false) so a later IntersectionObserver check of vid.paused
  // wrongly skips the real play call. Fix: only trigger via IntersectionObserver,
  // observe the section (not the absolute-positioned video element whose bounding
  // box can be unreliable), and call play() unconditionally each time the section
  // enters view so a pending-but-stalled state is always cleared.

  qsa('.pe-story__video-el').forEach(function (vid) {
    vid.muted = true;

    var section = vid.closest('#product-editorial-story');
    var target  = section || vid;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          vid.play().catch(function () {});
        }
      }, { threshold: 0 });
      obs.observe(target);
    } else {
      vid.play().catch(function () {});
    }
  });

  // ─── 7. FAQ (search + accordion) ─────────────────────────────────────────────

  var faqRoot = qs('#product-editorial-faq');
  if (faqRoot) {
    qsa('.accordion-header', faqRoot).forEach(function (header) {
      header.addEventListener('click', function () {
        var content = header.nextElementSibling;
        if (!content || !content.classList.contains('accordion-content')) return;
        var willOpen = !content.classList.contains('show');
        content.classList.toggle('show', willOpen);
        header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    var faqSearch = qs('.faq-search', faqRoot);
    if (faqSearch) {
      faqSearch.addEventListener('input', function () {
        var search = this.value.toLowerCase().trim();
        qsa('.faq-group', faqRoot).forEach(function (group) {
          var anyVisible = false;
          qsa('.accordion-item', group).forEach(function (item) {
            var match = !search || item.textContent.toLowerCase().includes(search);
            item.style.display = match ? '' : 'none';
            if (match) anyVisible = true;
          });
          group.style.display = anyVisible ? '' : 'none';
        });
      });
    }
  }

});
